module.exports = __webpack_public_path__ + "img/4.16d9e99d.jpg";